import React, { useState } from 'react';
import {useTranslation} from 'react-i18next';
import { Button, FormControl, FormControlLabel, Grid, RadioGroup } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { datesNumToName, getWeekendDates } from '../../helpers/dateHelpers';
import { StyledRadio } from '../../assets/style/material/matSyles';
import { useEffect } from 'react';
import { usePairingPackage } from '../../providers/PairingPackage';
import AppSlider from "../AppSlider/AppSlider";
import './AppCalendar.scss';
import CustomCalendar from './CustomCalendar';

// TODO make into util
interface CalendarInterface {
  dates: Date[],
  dateConditions: String,
}

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: 15,
    fontWeight: 'bold'
  },
  font: {
    fontSize: 15
  }
}));

const AppCalendar = ({
  displayFiltersClicked,
  selectedDate,
  setSelectedFilters,
  selectedFilters
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const pairingContext = usePairingPackage();
  const [selectedDates, setSelectedDates] = useState<CalendarInterface>({dates: selectedFilters.selectedDateFilter.dates, dateConditions: selectedFilters.selectedDateFilter.dateConditions});
  const [blockDates, setBlockDates] = useState<any>({});

  // Setting state, interface, Mapper for -> On, Off and Tafb sliders
  const [onOffTafInfo,setOnOffTafInfo]= useState<any>({
    onDuty: {range:[0 ,0], selection: selectedFilters.selectedDateFilter.onDuty.selected},
    offDuty: {range:[0 ,0], selection: selectedFilters.selectedDateFilter.offDuty.selected},
    tafb: {range:[0 ,0], selection: selectedFilters.selectedDateFilter.tafb.selected},
  });

  const sliderDefaultState = {
    onDuty: onOffTafInfo.onDuty,
    offDuty: onOffTafInfo.offDuty,
    tafb: onOffTafInfo.tafb,
  };  
  interface selectedDetailsInterface {
    onDuty: string;
    offDuty: string;
    tafb: string;
    selectHours: string;
  }

  const labelNames: selectedDetailsInterface = {
    onDuty: t("filters.dateTime.onOffTafbInfo.onDuty"),
    offDuty: t("filters.dateTime.onOffTafbInfo.offDuty"),
    tafb: t("filters.dateTime.onOffTafbInfo.tafb"),
    selectHours: t("filters.dateTime.onOffTafbInfo.selectHours"),
  };

  const stateMapper = new Map();
    stateMapper.set('onDuty', 'onduty');
    stateMapper.set('offDuty', 'offduty');
    stateMapper.set('tafb', 'tafb');

  // useEffect for on, off, tafb initial state and for btn Clear Filter
  useEffect(()=>{
      if (!pairingContext.pairingPackageData.pairingList.length) {
        return;
      }
  
       //sort function
       let sortAsend = (a,b) => a > b ? 1 : b > a ? -1 : 0;
       let builtState = Object.keys(sliderDefaultState).map(key => ({[key]: sliderDefaultState[key].range = getMinMax(pairingContext.pairingPackageData.pairingList.map(f => f[stateMapper.get(key)]), sortAsend)}));
   
       let arrayToObject = builtState.reduce((a,n) => {
         let tempKey = Object.keys(n)[0];
         let defaultObj = {range: n[tempKey], selection: n[tempKey]};
         return {...a, [tempKey]: defaultObj};
       },{} as any);
   
       setOnOffTafInfo({
         ...onOffTafInfo,
         ...arrayToObject
       });
         
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[pairingContext.pairingPackageData.pairingList]);

  useEffect(() => {
    setSelectedDates({ dates: selectedFilters.selectedDateFilter.dates, dateConditions: selectedFilters.selectedDateFilter.dateConditions });

    if(!selectedFilters.selectedDateFilter.dates.length){
      resetCalendarSelection();
    }
    
    setOnOffTafInfo({
      onDuty: { ...onOffTafInfo.onDuty, selection: selectedFilters.selectedDateFilter.onDuty.selected[0]===-1 && selectedFilters.selectedDateFilter.onDuty.selected[1]===-1 ? onOffTafInfo.onDuty.range : selectedFilters.selectedDateFilter.onDuty.selected},
      offDuty: { ...onOffTafInfo.offDuty, selection: selectedFilters.selectedDateFilter.offDuty.selected[0]===-1 && selectedFilters.selectedDateFilter.offDuty.selected[1]===-1 ? onOffTafInfo.offDuty.range : selectedFilters.selectedDateFilter.offDuty.selected},
      tafb: { ...onOffTafInfo.tafb, selection: selectedFilters.selectedDateFilter.tafb.selected[0]===-1 && selectedFilters.selectedDateFilter.tafb.selected[1]===-1 ? onOffTafInfo.tafb.range : selectedFilters.selectedDateFilter.tafb.selected },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters])
    
  const getMinMax = (arr, customFunction:any = undefined) => {
    if (customFunction){
      let min = arr.slice().sort(customFunction);
      return [min[0], min[arr.length-1]];
    }
    let a = arr.slice().sort();
    return [a[0], a[a.length-1]];
  };

  useEffect(() => {
    if (!pairingContext.pairingPackageData.blockdates) {
      return;
    }
    setBlockDates({
      ...pairingContext.pairingPackageData.blockdates,
      start: new Date(`${pairingContext.pairingPackageData.blockdates.start}T00:00:00`),
      end: new Date(`${pairingContext.pairingPackageData.blockdates.end}T00:00:00`)
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pairingContext.pairingPackageData.blockdates?.start])

  // on change event for the on, off and tafb sliders
  const onChangeSlider = (event: any, newValue: number| number[]) => {

    setOnOffTafInfo({
      ...onOffTafInfo,
      [event.target.name]: {...onOffTafInfo[event.target.name], selection: (newValue as number[])}
    });     
    
  };

  const resetCalendarSelection = () => {
    const dateItems = document.querySelectorAll(".calendar-container .day");
    if(dateItems && dateItems.length > 0){     
      dateItems.forEach(dateElement =>{
        const selectedDateElement = dateElement as Element;              
            selectedDateElement.classList?.remove("selected-calendar-date");                
        });
    }
  }

  var isWeekendCalEnabled = false;
  var isWeekdayCalEnabled = false;
  const handleWeekClick = (isWeekend = true) => {
    if (!pairingContext.pairingPackageData.blockdates) {
      return;
    }
    let getDates = getWeekendDates(pairingContext.pairingPackageData.blockdates.start, pairingContext.pairingPackageData.blockdates.end)
    if(isWeekend){
      isWeekendCalEnabled = !isWeekendCalEnabled;
    }else{
      isWeekdayCalEnabled = !isWeekdayCalEnabled;
    }

    const dateItems = document.querySelectorAll(".calendar-container .day");
    if (dateItems && dateItems.length > 0) {
      const weekendTimes = getDates.weekend.map(d => d.getTime());
      const weekdayTimes = getDates.weekday.map(d => d.getTime());
      dateItems.forEach(dateElement => {
        const calendarDateElement = dateElement as Element;
        if (calendarDateElement) {
          let dateItemsTimeVal = new Date(calendarDateElement.getAttribute("data-value") + " 00:00").getTime();
          if (isWeekend && weekendTimes.includes(dateItemsTimeVal)) {
            if (isWeekendCalEnabled) {
              if (!calendarDateElement.classList.contains("selected-calendar-date")) { 
                calendarDateElement.classList.add("selected-calendar-date"); 
              }
            } else {
              if (calendarDateElement.classList.contains("selected-calendar-date")) { 
                calendarDateElement.classList.remove("selected-calendar-date"); 
              }
            }
          }
          if (!isWeekend && weekdayTimes.includes(dateItemsTimeVal)) {
            if (isWeekdayCalEnabled) {
              if (!calendarDateElement.classList.contains("selected-calendar-date")) { 
                calendarDateElement.classList.add("selected-calendar-date"); 
              }
            } else {
              if (calendarDateElement.classList.contains("selected-calendar-date")) { 
                calendarDateElement.classList.remove("selected-calendar-date"); 
              }
            }
          }
        }
      })
    }
  };

  useEffect(() => {
    if (!displayFiltersClicked) {
      return;
    }

    const selectedDateItems = document.querySelectorAll(".calendar-container .selected-calendar-date");
    const selectedDateArray: any = [];
    if(selectedDateItems && selectedDateItems.length > 0){
      selectedDateItems.forEach(dateElement =>{
        const selectedDateElement = dateElement as Element;
        if(selectedDateElement){
          selectedDateArray.push(new Date(selectedDateElement.getAttribute("data-value")+" 00:00"));
        }       
      })
    }
    
    // set the selected filter in pairing package scope
    setSelectedFilters((prevState) => {
      return {
        ...prevState,
        selectedDateFilter: {
          dates: selectedDateArray || [],
          dateConditions: selectedDates.dateConditions || "1",
          onDuty: { selected: onOffTafInfo.onDuty.selection || [-1. -1] },
          offDuty: { selected: onOffTafInfo.offDuty.selection || [-1, -1] },
          tafb: { selected: onOffTafInfo.tafb.selection || [-1, -1] },
        }
      }
    });

    setSelectedDates((prevState)=>{
      return {
        ...prevState,
        dates:selectedFilters.selectedDateFilter.dates
      }
    });
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayFiltersClicked]);


  return (
    <>
    <div className='calendar-heading'>
        <div className='title'>Date Range:</div>
        <div className='calendar-month'>
          {new Date(selectedDate) ? datesNumToName(new Date(selectedDate).getMonth(), 1) : 'N/A' } {new Date(selectedDate) ? new Date(selectedDate).getFullYear() : 'N/A' } <span className='calendar-total-days'>({blockDates.days ? blockDates.days : 'N/A'} Days)</span></div>
    </div>
      <CustomCalendar blockDates={blockDates} selectedFilters={selectedFilters}/>
      <Grid className='date-weekdays-button' container spacing={2}>
        <Grid item xs={8}>
            <Button className='btn-grey' onClick={() => handleWeekClick(false)}>
                {t('filters.dateTime.weekdays')}
            </Button>
        </Grid>
        <Grid item xs={4}>
            <Button className='btn-grey' onClick={() => handleWeekClick()}>
                {t('filters.dateTime.weekends')}
            </Button>
        </Grid>
    </Grid>

    <FormControl className='form-control'>
        <RadioGroup aria-label='layover duration' name='layover' value={selectedDates.dateConditions} onChange={(e) => setSelectedDates({...selectedDates, dateConditions: e.target.value})}>
            <FormControlLabel className='layover-label' value={"1"} control={<StyledRadio />}  label={
              <span>
                <span className={classes.label}>{t('filters.dateTime.hide')}</span>
                <span className={classes.font}>{t('filters.dateTime.doesNotOperate')}</span>
              </span>
            } />            
            <FormControlLabel className='layover-label font-control-label-mt-20' value={"3"} control={<StyledRadio />}  label={
              <span>
                <span className={classes.font}>{t('filters.dateTime.departsAndArrives')}</span>
                <span className={classes.label}>{t('filters.dateTime.departsAndArrives1')}</span>
                <span className={classes.font}>{t('filters.dateTime.departsAndArrives2')}</span>
              </span>
            } />
            <FormControlLabel className='layover-label' value={"5"} control={<StyledRadio />}  label={
              <span>
                <span className={classes.font}>{t('filters.dateTime.occursOn')}</span>
                <span className={classes.label}>{t('filters.dateTime.occursOn1')}</span>
                <span className={classes.font}>{t('filters.dateTime.occursOn2')}</span>
              </span>
            } />
            <FormControlLabel className='layover-label font-control-label-mt-20' value={"2"} control={<StyledRadio />}  label={
              <span>
                <span className={classes.font}>{t('filters.dateTime.startsOn')}</span>
                <span className={classes.label}>{t('filters.dateTime.startsOn1')}</span>
                <span className={classes.font}>{t('filters.dateTime.startsOn2')}</span>
              </span>
            } />
            <FormControlLabel className='layover-label' value={"4"} control={<StyledRadio />}  label={
              <span>
                <span className={classes.font}>{t('filters.dateTime.endsOn')}</span>
                <span className={classes.label}>{t('filters.dateTime.endsOn1')}</span>
                <span className={classes.font}>{t('filters.dateTime.endsOn2')}</span>
              </span>
            } />            
        </RadioGroup>
    </FormControl>

    <Grid className='date-buttons' container item justifyContent='flex-end' spacing={2}>
        <Grid item xs={4}>
            <Button className='btn-grey' onClick={() => {
              setSelectedDates({dateConditions: '1', dates:[]});
              resetCalendarSelection();
              }}>
                {t('filters.dateTime.clear')}
            </Button>
        </Grid>
    </Grid>

      {/* on duty slider */}
      <AppSlider label={labelNames.onDuty} desc={labelNames.selectHours} min={onOffTafInfo.onDuty.range[0]} max={onOffTafInfo.onDuty.range[1]} value={onOffTafInfo.onDuty.selection} onChange={onChangeSlider} name='onDuty' />

      {/* off duty slider */}
      <AppSlider label={labelNames.offDuty} desc={labelNames.selectHours} min={onOffTafInfo.offDuty.range[0]} max={onOffTafInfo.offDuty.range[1]} value={onOffTafInfo.offDuty.selection} onChange={onChangeSlider} name='offDuty' />

      {/* tafb slider */}
      <AppSlider label={labelNames.tafb} desc={labelNames.selectHours} min={onOffTafInfo.tafb.range[0]} max={onOffTafInfo.tafb.range[1]} value={onOffTafInfo.tafb.selection} onChange={onChangeSlider} name='tafb' />  
    </>
  );
};

export default React.memo(AppCalendar);